var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-698 -1218) translate(698 1218)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CB0F1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11 18L25 18M18 11L18 25"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddCircle);
export default __webpack_public_path__ + "static/media/ic-add-circle.51b335286fa4f77644eb26ec5e8c6f98.svg";
export { ForwardRef as ReactComponent };